import styled from "styled-components";
import Div from "app/components/Div";

export default styled(Div).attrs(({ width, height }) => ({
  width: width || "6px",
  height: height || "6px",
  borderRadius: "100%",
}))``;
